
export const listDepoussierage = [
    { id: 1, text: "Création des trappes de visite" },
    { id: 2, text: "Dépoussiérage des réseaux de ventilation" },
    { id: 3, text: "Désinfection des réseaux de ventilation" },
    { id: 4, text: "Dépoussiérage des bouches diffuseurs" },
]
export const listEntrEvap = [
    { id: 1, text: "Dépose des bacs" },
    { id: 2, text: "Vérification" },
    { id: 3, text: "Désinfection des batteries" },
    { id: 4, text: "Désinfection du bac" },
    { id: 5, text: "Désinfection des écoulements" },
]

export const listEntrHotte = [
    { id: 1, text: "Tourelle" },
    { id: 2, text: "Moteur" },
    { id: 3, text: "Conduit Aéraulique" },
    { id: 4, text: "Filtre" },
    { id: 5, text: "Obturateur" },
    { id: 6, text: "Grattage des graisses calcinée" },
    { id: 7, text: "Extraction Grasse" }
]

export const listImputations = [
    { id: 1, text: "Installation" },
    { id: 2, text: "Maintenance / Entretien" }
]

export const listMaintenance = [
    { id: 1, text: "Vérification" },
    { id: 2, text: "Moteur" },
    { id: 3, text: "Poulie" },
    { id: 4, text: "Courroie" },
    { id: 5, text: "Volute" },
    { id: 6, text: "Pallier" },
    { id: 7, text: "Remplacement" },
    { id: 8, text: "Vérification électrique" },
    { id: 9, text: "Alignement" },
]

export const listInstallation = [
    { id: 1, text: "CTA" },
    { id: 2, text: "Chaudière" },
    { id: 3, text: "Caissons VMC" },
    { id: 4, text: "Aérotherme" },
    { id: 5, text: "Évaporateur" },
    { id: 6, text: "Ligne production" },
    { id: 7, text: "Climatisation" },
    { id: 8, text: "Hotte" },
    { id: 9, text: "Condenseur" },
    { id: 10, text: "Radiant" },
    { id: 11, text: "Gaine textile" },
    { id: 12, text: "Autre" },
]

export const listMEP = [
    { id: 1, text: "Rédaction des autorisations" },
    { id: 2, text: "Balisage de la zone" },
    { id: 3, text: "Protection des installations" },
    { id: 4, text: "Prise en compte des consignes de sécurité" }
]

export const effectuer = [
    { id: 1, text: "Devis" },
    { id: 2, text: "Commande" },
    { id: 3, text: "Travaux" },
]

export const weekList = [
    "DIM",
    "LUN",
    "MAR",
    "MER",
    "JEU",
    "VEN",
    "SAM"
]

export const listVMC = [
    { id: 1, text: "Dépoussiérage et désinfection du caisson d’extraction / soufflage" },
    { id: 2, text: "Graissage des roulements/paliers/turbines" },
    { id: 3, text: "Réalignement des poulies" },
    { id: 4, text: "Mesure des débits en sortie de caisson" },
    { id: 5, text: "Dépoussiérage et désinfection des réseaux de ventilations" },
    { id: 6, text: "Dépoussiérage et désinfection des bouches" },
    { id: 7, text: "Dépoussiérage et désinfection des diffuseurs" },
]

export const listCTA = [
    { id: 1, text: "Entretien des filtres" },
    { id: 2, text: "Remplacement des filtres" },
    { id: 3, text: "Mise en propreté des centrales de traitement d'air (CTA)" },
    { id: 4, text: "Mise en place de la centrale d'aspiration" },
    { id: 5, text: "Réseau soufflage" },
    { id: 6, text: "Bouches / grilles de soufflage" },
    { id: 7, text: "Réseau reprise" },
    { id: 8, text: "Bouches / grilles de reprise" }
]

export const listAero = [
    { id: 1, text: "Mise en propreté de l'aérotherme et ventilateur d'air" },
    { id: 2, text: "Contrôle du moteur et de la turbine" },
    { id: 3, text: "Contrôle des organes électrique / gaz / hydraulique" },
    { id: 4, text: "Contrôle bon fonctionnement" }
]

export const listCondenseur = [
    { id: 1, text: "Mise en propreté du condenseur" },
    { id: 2, text: "Contrôles préliminaires" },
    { id: 3, text: "Contrôle des sondes" },
    { id: 4, text: "Dépose des paniers" },
    { id: 5, text: "Ouverture des bacs de condensats" },
    { id: 6, text: "Application d'une solution détergenre et désinfectante" },
    { id: 7, text: "Rinçage à l'eau supressée" },
    { id: 8, text: "Nettoyage des écoulements" }
]

export const listEvap = [
    { id: 1, text: "Mise en propreté du condenseur" },
    { id: 2, text: "Démontage de l'évaporateur" },
    { id: 3, text: "Dépose du carter de protection du ventilateur" },
    { id: 4, text: "Dépose des paniers" },
    { id: 5, text: "Ouverture des bacs de condensats" },
    { id: 6, text: "Pulvérisation d'une solution détergente et désinfectante" },
    { id: 7, text: "Nettoyage et désinfection du condenseur à air et du condensat" },
    { id: 8, text: "Brossage et nettoyage de l'intérieur de l'évaporateur et des moto-ventilateurs" },
    { id: 9, text: "Nettoyage et désinfection de la batterie" },
    { id: 10, text: "Rinçage à l'eau surpressée" },
    { id: 11, text: "Nettoyage et désinfection du ventilateur" },
    { id: 12, text: "Contrôle des roulements, paliers, étanchéité, électricité" },
    { id: 13, text: "Désinfection de tous les éléments contre les bactéries" },
    { id: 14, text: "Remise en place du carter de protection et du condensat" },
]

export const listRad = [
    { id: 1, text: "Entretien de la tête de brûleur et de l'électrode" },
    { id: 2, text: "Entretien et nettoyage des tubes radiants" },
    { id: 3, text: "Vérification ensemble des organes de fonctionnement" },
    { id: 4, text: "Contrôle du fonctionnement" },
    { id: 5, text: "Contrôle du boîtier d'allumage" },
    { id: 6, text: "Contrôle des électrodes" },
    { id: 7, text: "Contrôle de l'électrovanne de sécurité" },
    { id: 8, text: "Contrôle du régulateur" },
    { id: 9, text: "Contrôle du brûleur" },
    { id: 10, text: "Contrôle de l'ensemble moto-ventilateur" },
    { id: 11, text: "Contrôle du pressostat" },
    { id: 12, text: "Test de combustion" },
    { id: 13, text: "Vérification électrode" },
    { id: 14, text: "Vérification rampe gaz" },
    { id: 15, text: "Ramonage" },
    { id: 16, text: "Serrage des connexions" },
    { id: 17, text: "Nettoyage" },
    { id: 18, text: "Contrôle de la terre" },
]

export const listGaineText = [
    { id: 1, text: "Dépose de la gaine" },
    { id: 2, text: "Nettoyage et traitement de la gaine" },
    { id: 3, text: "Repose de la gaine" },
]

export const listeLigneProd = [
    { id: 1, text: "Mise en propreté d'une extraction grasse" },
    { id: 2, text: "Mise en propreté d'une extraction d'air ambiant" },
]

export const listChaudTypeB = [
    { id: 1, text: "Mesure, une fois les opérations de réglage et d'entretien de l'appareil réalisées, de la teneur en monoxyde de carbone (CO) dans l'ambiance et à proximité de l'appareil en fonctionnement" },
    { id: 2, text: "Vérification que la teneur en monoxyde de carbone mesurée est inférieure à 50ppm" },
    { id: 3, text: "Vérification de l'état, de la nature et de la géométrie du conduit de raccordement de l'appareil" },
]

export const listeChaudiere = [
    { id: 1, text: "Nettoyage du corps de chauffe, du brûleur, de la veilleuse, de l'extracteur (si incorporé à l'appareil)" },
    { id: 2, text: "Vérification du circulateur (si incorporé dans l'appareil)" },
    { id: 3, text: "Vérification et réglage des organes de régulation (si incorporé dans l'appareil)" },
    { id: 4, text: "Vérification des dispositifs de sécurité de l'appareil" },
    { id: 5, text: "Vérification des débits de gaz" },
    { id: 6, text: "Chaudière équipée de brûleurs à air soufflé, mesure de la température des fumées et mesure de la teneur en dioxyde de carbone (CO²) ou en oxygène (O²) dans les fumées" },
    { id: 7, text: "Chaudière fioul, détermination de l'indice de noircissement" },
    { id: 8, text: "Chaudière à circuit de combustion non étanche (type B):" },
]

export const listClim = [
    { id: 1, text: "Nettoyage unité intérieure" },
    { id: 2, text: "Désinfection batterie et filtre" },
    { id: 3, text: "Nettoyage groupe extérieur" },
    { id: 4, text: "Contrôle étanchéité avec détecteur normalisé des raccords frigorifiques" },
    { id: 5, text: "Contrôle partie électricité (connexions, intensité ..." },
    { id: 6, text: "Contrôle bon fonctionnement avec relevés temprératures, pressions, ..." },
]

export const typologie = [
    {id:1, text: "Neuf"},
    {id:2, text: "Remplacement"},
    {id:3, text: "Réparation"},
]